<template>
  <div>
    <div class="ppc26-footer clear-both container mx-auto p-0" v-show="menuData">
      <footer class="py-8">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="items-center justify-around mx-auto grid md:grid-cols-3 grid-cols-1 gap-4 upper-footer-section">
            <img
              class="logo"
              src="~/assets/images/logo_spring_green.png"
              alt="Spring Green Logo"
              loading="lazy" />

            <div
              class="contact-info flex-col sm:flex-row flex flex-wrap gap-4 justify-center">
              <div class="flex flex-nowrap justify-center sm:justify-start gap-1 items-center">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 22 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="inline-block icon-location">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                    fill="#517185" />
                  <mask
                    id="mask0"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="22"
                    height="28">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.0489 15.0653C8.60126 15.0653 6.61722 13.125 6.61722 10.7314C6.61722 8.33776 8.60126 6.39751 11.0489 6.39751C13.4962 6.39751 15.4806 8.33776 15.4806 10.7314C15.4806 13.125 13.4962 15.0653 11.0489 15.0653ZM21.9782 10.4774L21.8538 9.44257L21.6274 8.42411L21.3012 7.43165L20.8781 6.47453L20.3627 5.56242L19.7589 4.70297L19.0737 3.90454L18.3121 3.17478L17.482 2.52103L16.5906 1.94796L15.648 1.4629L14.6608 1.06885L13.6401 0.770145L12.5939 0.56912L11.5327 0.467773H10.4667L9.40612 0.56912L8.3599 0.770145L7.3389 1.06885L6.35199 1.4629L5.40872 1.94796L4.51795 2.52103L3.68786 3.17478L2.92629 3.90454L2.24074 4.70297L1.63734 5.56242L1.12122 6.47453L0.698846 7.43165L0.372604 8.42411L0.146246 9.44257L0.0218176 10.4774L0 11.5198L0.0818161 12.559L0.265902 13.5861L0.550554 14.5909L0.933385 15.5637L1.41099 16.4958L1.97824 17.3779L2.63039 18.2027L10.9998 27.7916L19.3696 18.2027L20.0218 17.3779L20.589 16.4958L21.0663 15.5637L21.4491 14.5909L21.7338 13.5861L21.9178 12.559L22 11.5198L21.9782 10.4774Z"
                      fill="white" />
                  </mask>
                  <g mask="url(#mask0)"></g>
                </svg>
                <span class="font-bold" v-if="branchLocation">
                  {{ branchLocation }}
                </span>
              </div>
              <div class="flex flex-nowrap justify-center sm:justify-start gap-1 items-center" v-if="branchPhone">
                <span class="font-bold text-black">Phone:</span>
                <span>{{ formatPhoneNumber(branchPhone) ?? branchPhone }}</span>
              </div>
              <div class="flex flex-nowrap justify-center sm:justify-start gap-1 items-center" v-if="branchHours">
                <span class="font-bold text-black">Hours:</span>
                <span>{{ branchHours }}</span>
              </div>
            </div>

            <div
              class="flex items-center mx-auto mb-4 sm:mb-0"
              v-if="menuData && menuData.social_media_links">
              <div class="flex mx-auto items-center gap-4">
                <a
                  v-for="link in menuData.social_media_links"
                  :key="link.icon"
                  :href="link.url"
                  target="_blank">
                  <PPCSocialMediaIcon :icon="link.icon" />
                </a>
              </div>
            </div>
          </div>

          <div
            class="flex items-center md:mx-auto md:mt-8 footer-privacy-links">
            <div class="flex-column md:flex-row mx-auto items-center">
              <!-- <p
                class="px-3 py-2 md:mx-1 text-xs font-light md:text-nowrap"
                v-text="menuData && menuData.copyright_text" /> -->
              <nav>
                <ul
                  class="md:flex flex-wrap text-center my-0"
                  v-if="menuData && menuData.navigation_links">
                  <li class="text-xs" v-text="menuData && menuData.copyright_text"></li>
                  <li
                    v-for="item in menuData.navigation_links"
                    :key="item.text">
                    <a
                      :href="item.url"
                      class="px-3 py-2 md:mx-1 text-sm text-xs font-light"
                      v-text="item.text" />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";
import { formatPhoneNumber } from "~/utils/phone";

const menuData = ref(undefined);
const store: Store<State> = useStore();

const persistedState = computed(() => store.state?.persistedState);
const branchLocation = computed(() => persistedState.value?.branchLocation || "");
const branchPhone = computed(
  () =>
    persistedState.value?.branchMarchExPhone?.FieldValue ||
    persistedState.value?.branchPhone?.FieldValue ||
    "",
);
const branchHours = computed(() => {
  const franchiseData = persistedState.value?.franchiseData as Record<string, any> | undefined;
  if (!franchiseData) return "";

  const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const day = dayNames[new Date().getDay()];
  if (!franchiseData[`is_open_${day}`]) return "Closed";

  const open = franchiseData[`${day}_time_open`] || "08:00";
  const close = franchiseData[`${day}_time_close`] || "17:00";
  return `${formatTime(open)} - ${formatTime(close)}`;
});

const formatTime = (time: string) => {
  const [hours, minutes] = time.split(":").map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return time;
  const suffix = hours >= 12 ? "pm" : "am";
  const hour = hours % 12 || 12;
  return `${hour}:${minutes.toString().padStart(2, "0")} ${suffix}`;
};

const { $config, $axios, $sg } = useNuxtApp();

onMounted(async () => {
  const persistedState = store.state?.persistedState;
  const menuDataResponse = await $sg.getOctoberData("pages/footer");
  menuData.value = menuDataResponse;

  let infoData = null;

  if (persistedState.branchInfo || persistedState.branchCode) {
    infoData = persistedState.branchInfo?.BranchInfo?.InfoData;

    if (!infoData) {
      infoData = await $axios
        .get(
          $config.public.sgCmsApi +
            `branch/${persistedState.branchCode}/branchinfo`,
        )
        .then((response) => response.data.BranchInfo.InfoData)
        .catch((error) => ({ error: error, response: error.response.data }));
    }
  }

  if (infoData) {
    const fbUrl = infoData.find((data) => data.FieldName === "Facebook URL");

    if (fbUrl?.FieldValue) {
      menuData.value.social_media_links.find((a) => a.icon === "facebook").url =
        fbUrl.FieldValue;
    }
  }
});
</script>

<style>
.ppc26-footer footer {
  background-color: #fff;
}

.ppc26-footer .footer-privacy-links,
.ppc26-footer .footer-privacy-links a {
  color: #517185;
}

.ppc26-footer li {
  /* margin-top: 1rem; 
  display: flex;
  align-items: center;
  justify-content: center; */
  display: inline-block;
}

.ppc26-footer li a {
  text-decoration: underline;
}

.ppc26-footer ul {
  margin-left: 0;
  list-style-type: none;
  margin-bottom: 0;
}

.ppc26-footer .upper-footer-section img {
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 768px) {
  .ppc26-footer li {
    margin-top: 0;
    margin-bottom: 0;
    margin-top: 1rem;
    display: flex;
    align-items: center;
  }

  .ppc26-footer .upper-footer-section {
    grid-template-columns: 200px 1fr 200px;
  }

  .ppc26-footer .footer-privacy-links li:after {
    content: "|";
  }
}
</style>
